// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1n1H1","item":"PaymentsMobile_item__1Rezn","label":"PaymentsMobile_label__vT8Vx","amount":"PaymentsMobile_amount__3k4wy"};